// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import NewswireDisclaimerComp from '../../components/NewswireDisclaimerPage/NewswireDisclaimerPage';

const NewswireDisclaimer: React.FC = () => {
    return (
        <Entrypoint>
            <NewswireDisclaimerComp />
        </Entrypoint>
    );
}

export default NewswireDisclaimer;